
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipControlAa as ObiOwnShipControlAaElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-control-aa.js';
 
 
 

 
 export const ObiOwnShipControlAa = createComponent({
   react: React,
   tagName: 'obi-own-ship-control-aa',
   elementClass: ObiOwnShipControlAaElement,
   events: {
     
   }
  });
 
 